import { format } from 'date-fns';

export const getDateTime = (value?: string | number | null) => {
  if (!value) return '';

  const date = new Date(value);

  return format(date, 'HH:mm');
};
